import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { ProductBroadbandResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const productBroadband = {
    record(data: typeof Requests.ProductBroadband.Record.Input) {
        return post<typeof data, ProductBroadbandResponseTypes.Record>(
            `/product-broadband/record`,
            data,
        );
    },
    subscriptionRecord(id: string) {
        return (data: typeof Requests.ProductBroadband.SubscriptionRecord.Input) => {
            return post<typeof data, ProductBroadbandResponseTypes.SubscriptionRecord>(
                `/product-broadband/subscription-record/${id}`,
                data,
            );
        };
    },
    create(data: typeof Requests.ProductBroadband.Create.Input) {
        return post<typeof data>(`/product-broadband/create`, data);
    },
    obtain(id: string) {
        return get<ProductBroadbandResponseTypes.Obtain>(`/product-broadband/obtain/${id}`);
    },
    enable(id: string) {
        return postEmpty(`/product-broadband/enable/${id}`);
    },
    disable(id: string) {
        return postEmpty(`/product-broadband/disable/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<ProductBroadbandResponseTypes.Select>(
                `/product-broadband/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.ProductBroadband.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/product-broadband/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
